import { APICore } from './apiCore'

const api = new APICore()

function getPuntos (params) {
  const baseUrl = '/puntos-interes'
  return api.get(baseUrl, params)
}

function getPunto (id) {
  const baseUrl = `/puntos-interes/${id}`
  return api.get(baseUrl, {})
}

function addPunto (params) {
  const baseUrl = '/puntos-interes'
  return api.createWithFile(baseUrl, params)
}

function updatePunto (params) {
  const baseUrl = '/puntos-interes'
  return api.updateWithFile(baseUrl, params)
}

function deletePunto (params) {
  const baseUrl = '/puntos-interes'
  return api.delete(baseUrl, params)
}

export { getPuntos, getPunto, addPunto, updatePunto, deletePunto }
